import { createContext, useContext } from 'react';

export interface DOIContextValue {
  isDOIRequired: boolean;
  isLocked: boolean;
  timeRemaining: number;
  formattedTime: string;
  isModalOpen: boolean;
  resendEmail: () => Promise<void>;
  resendCooldown: number;
  isResending: boolean;
  resendSuccess: boolean;
}

export const DOIContext = createContext<DOIContextValue | null>(null);

export function useDOI(): DOIContextValue {
  const context = useContext(DOIContext);
  if (context === null) {
    throw new Error('useDOI must be used within a DOIProvider');
  }
  return context;
}
